import React, { useState } from 'react';
import logoZkcandy from '../assets/images/logo-zkcandy.svg';
import iconMenu from '../assets/images/icon-menu.svg';
import iconClose from '../assets/images/icon-close.svg';
import iconDiscord from '../assets/images/icon-header-discord.webp';
import iconTelegram from '../assets/images/icon-header-telegram.webp';
import iconX from '../assets/images/icon-header-x.webp';
import iconGamecenter from '../assets/images/icon-header-gamecenter.webp';
import { Link } from 'react-router-dom';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'

export default function Header() {

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(prevState => !prevState);
    };

    return (
        <nav className='navbar py-2'>
            <div className="absolute top-0 left-0 pointer-event-none w-full h-full bg-[#000000ba] backdrop-blur-sm -z-10"></div>
            <div className="container mx-auto">
                <div className='flex items-center justify-between px-3'>
                    <Link onClick={() => { window.location.replace("/"); }}  className='logo md:w-[150px] w-[120px] hover:scale-[1.1] eas-in duration-300'>
                        <img className='w-full' src={logoZkcandy} alt='Logo' />
                    </Link>

                    <div className={isMenuOpen ? 'hidden btn-menu show' : 'hidden btn-menu'} onClick={toggleMenu}>
                        <img className='menu' src={iconMenu} alt='menu' />
                        <img className='close' src={iconClose} alt='close' />
                    </div>

                    <div className={`${isMenuOpen ? 'menu-container show' : 'menu-container '} w-full flex xl:flex-row flex-col justify-between items-center xl:pb-0 pb-20 md:top-[50px] top-[45px]`}>
                        <div className='menu flex items-center xl:flex-row flex-col xl:ms-5'>
                            <Link onClick={toggleMenu} to='/#homepage' className='menu-item'>Home</Link>
                            <Link onClick={() => { window.location.replace("/about/#about"); toggleMenu() }} to='/about/#about' className='menu-item'>About Us</Link>
                            <Menu as="div" className="dropdown relative inline-block text-center xl:text-left">
                                <div>
                                    <MenuButton className="menu-item inline-flex items-center">
                                        <Link
                                            onClick={() => { window.location.replace("/build/#built-for-web3"); toggleMenu() }}
                                            className="mr-2"
                                        >
                                            Build
                                        </Link>
                                      
                                        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.7 6.93333L0.7 1.6C0.205573 0.940764 0.675752 0 1.4998 0H9.50143C10.3255 0 10.7944 0.940764 10.3 1.6L6.3 6.93333C5.9 7.46667 5.1 7.46667 4.7 6.93333Z" fill="white" />
                                        </svg>

                                    </MenuButton>
                                </div>

                                <MenuItems
                                    modal={false}
                                    transition
                                    className="xl:absolute left-0 z-10 mt-2 rounded-md bg-black menu-items "
                                >
                                    <div className="py-4 flex flex-col whitespace-nowrap">
                                        <MenuItem>
                                            <Link
                                                onClick={() => { window.location.replace("/build/#built-for-web3"); toggleMenu() }}
                                                className="menu-item my-2"
                                            >
                                                Why Build On ZKcandy
                                            </Link>
                                        </MenuItem>
                                        <MenuItem>
                                            <Link
                                                onClick={() => { window.location.replace("/build/#start-building"); toggleMenu() }}
                                                className="menu-item"
                                            >
                                                Start Building
                                            </Link>
                                        </MenuItem>
                                        <MenuItem>
                                            <a
                                                onClick={toggleMenu}
                                                href="https://docs.zkcandyapi.com/"
                                                target='_blank'
                                                rel="noreferrer"
                                                className="menu-item"
                                            >
                                                Docs
                                            </a>
                                        </MenuItem>
                                        <MenuItem>
                                            <Link
                                                onClick={() => { window.location.replace("/build/#litepaper"); toggleMenu() }}
                                                className="menu-item"
                                            >
                                                LitePaper
                                            </Link>
                                        </MenuItem>
                                    </div>
                                </MenuItems>
                            </Menu>
                            <Link
                                onClick={() => { window.location.replace("/#games-on-zkcandy"); toggleMenu() }} className='menu-item'>Games</Link>
                            <a onClick={toggleMenu} href='https://zkcandy.medium.com/' target='_blank' rel="noreferrer" className='menu-item'>Blog</a>
                            <a onClick={toggleMenu} href='https://candyfoundation.xyz/' target='_blank' rel="noreferrer" className='menu-item'>Foundation</a>
                            {/* <a onClick={toggleMenu} href='https://portal.zkcandy.io/' target='_blank' className='menu-item'>Portal</a> */}
                        </div>

                        <div className="menu flex items-center xl:flex-row flex-col">
                            <div className="flex">
                                <a onClick={toggleMenu} href="https://t.me/zkcandygame_bot" target="_blank" rel="noreferrer"><img src={iconGamecenter} alt="ZKcandy Game Center" /></a>
                                <a onClick={toggleMenu} href="https://discord.com/invite/zkcandy" target="_blank" rel="noreferrer"><img src={iconDiscord} alt="ZKcandy Discord" /></a>
                                <a onClick={toggleMenu} href="https://x.com/ZKcandyHQ" target="_blank" rel="noreferrer"><img src={iconX} alt="ZKcandy X" /></a>
                                <a onClick={toggleMenu} href="https://t.me/zkcandy" target="_blank" rel="noreferrer"><img src={iconTelegram} alt="ZKcandy Telegram" /></a>
                            </div>

                            <a onClick={toggleMenu} href='https://portal.zkcandy.io/' target='_blank' rel="noreferrer" className='btn btn-white uppercase ms-4'>Connect To Mainnet</a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}